import { useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { achievementNotificationService } from '../services/achievementNotificationService';

export const useAchievementNotifications = () => {
  const { user } = useAuth();

  useEffect(() => {
    if (!user?.id) return;

    // Listen for achievement unlock events
    const handleAchievementUnlock = (event) => {
      const achievement = event.detail;
      
      // Request notification permission if not granted
      achievementNotificationService.requestNotificationPermission();
      
      // Trigger browser notification
      achievementNotificationService.triggerBrowserNotification(achievement);
    };

    // Add event listener
    window.addEventListener('achievementUnlocked', handleAchievementUnlock);

    // Cleanup
    return () => {
      window.removeEventListener('achievementUnlocked', handleAchievementUnlock);
    };
  }, [user?.id]);

  return {
    requestPermission: achievementNotificationService.requestNotificationPermission,
    isSupported: achievementNotificationService.isNotificationSupported(),
    isEnabled: achievementNotificationService.isNotificationEnabled()
  };
};